function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-marchesEscalier");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-marchesEscalier",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.5,26.5 L26.5,26.5 M3.5,3.5 L26.5,3.5 M26.5,26.5 L26.5,3.5 M19.5,11.5 L26.5,11.5 M3.5,19.5 L26.5,19.5 M13,9.5 L15,7.5 M17,9.5 L15,7.5 M13,12.5 L15,10.5 M17,12.5 L15,10.5 M13,15.5 L15,13.5 M17,15.5 L15,13.5 M3.5,11.5 L10.5,11.5 M3.5,26.5 L3.5,3.5",
  id: "Combined-Shape"
})));

const SvgIco30MarchesEscalier = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30MarchesEscalier, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-marchesEscalier.aaae8c13.svg";
export { ForwardRef as ReactComponent };